import { useField } from 'informed';

interface Props {
  children?: React.ReactNode;
  field: string;
  initialValue?: any;
}

const DisplayField = ({ children, field, initialValue }: Props) => {
  const { ref, render } = useField({ field, initialValue });

  return (
    <>
      {render(<input disabled={true} ref={ref} type="hidden" />)}

      {children ? <div>{children}</div> : null}
    </>
  );
};

export default DisplayField;
